import React from "react";
import { Link } from "react-router-dom";

const SocialMedia = () => {
    return (
        <div className="social py-5">
            <div className="overlay" />
            <div className="container main-box">
                <h1
                    className="my-heading"
                    style={{ paddingLeft: 20, marginBottom: 20 }}
                >
                    Follow us on Social Media
                </h1>
                <div className="boxes">
                    {/* <div className="box">
    <div className="top">
      <img src="assets/images/ccsu-logo-half.svg" alt="" />
      <div className="right">
        <h2>Chaudhary Charan Singh<br />university, meerut</h2>
      </div>
    </div>
    <Link to={"https://www.youtube.com/channel/UCBRUtlVs5IJiAM61KZqDXrg"} target="_blank">
      <img src="assets/images/youtube.svg" className="center-logo" alt="" />
    </Link>
    <div className="down">
      <img src="assets/images/social-media-1.png" alt="" />
    </div>
  </div> */}
                    <div className="box">
                        <div className="top">
                            <img src="assets/images/ccsu-logo-half.svg" alt="" />
                            <div className="right">
                                <h2>
                                    Chaudhary Charan Singh
                                    <br />
                                    University, Meerut
                                </h2>
                            </div>
                        </div>
                        <Link to={"https://www.facebook.com/CCSUFB"} target="_blank">
                            <img
                                src="assets/images/facebook.svg"
                                className="center-logo"
                                alt=""
                            />
                        </Link>
                        <div className="down">
                            <iframe
                                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FCCSUFB&tabs=timeline&width=416&height=296&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                                width={296}
                                height={500}
                                style={{ width: 416, border: "none", overflow: "hidden" }}
                                scrolling="no"
                                frameBorder={0}
                                allowFullScreen={true}
                                title="facebook"
                                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                            />
                        </div>
                    </div>
                    <div className="box">
                        <div className="top">
                            <img src="assets/images/ccsu-logo-half.svg" alt="" />
                            <div className="right">
                                <h2>
                                    Chaudhary Charan Singh
                                    <br />
                                    University, Meerut
                                </h2>
                            </div>
                        </div>
                        <Link to={"https://www.instagram.com/ccsuinsta/"} target="_blank">
                            <img
                                src="assets/images/instagram.svg"
                                className="center-logo"
                                alt=""
                            />
                        </Link>
                        {/* <div className="down">
                            <img src="assets/images/social-media-1.png" alt="" />
                            <iframe
                                src="https://widget.tagembed.com/146283?view"
                                style={{
                                    width: 416,
                                    height: 396,
                                    overflow: "auto",
                                    marginTop: "-48px"
                                }}
                                frameBorder={0}
                                title='instagram'
                                allowTransparency="true"
                            />
                            <iframe src="https://widget.tagembed.com/144108?view" style=" width=296;height:500px;overflow: auto;" frameborder="0" allowtransparency="true"></iframe>
                        </div> */}
                        <div className="down">
                            <iframe
                                src="https://widget.tagembed.com/146283?view" 
                                style={{
                                    width: "416px", 
                                    height: "396px",                                    
                                    overflow: "auto",
                                    marginTop: "-48px",
                                    border: "none", 
                                }}
                                title="Instagram Feed"
                                allowTransparency="true"
                                allowFullScreen={true}
                            />
                        </div>
                    </div>
                    <div className="box">
                        <div className="top">
                            <img src="assets/images/ccsu-logo-half.svg" alt="" />
                            <div className="right">
                                <h2>
                                    Chaudhary Charan Singh
                                    <br />
                                    University, Meerut
                                </h2>
                            </div>
                        </div>
                        <Link to={"https://twitter.com/ccsumeerut"} target="_blank">
                            <img
                                src="assets/images/twitter.svg"
                                className="center-logo"
                                style={{ backgroundColor: "#000", padding: 7, borderRadius: 5 }}
                                alt=""
                            />
                        </Link>
                        <div className="down">
                            <Link
                                className="twitter-timeline"
                                data-width={416}
                                data-height={296}
                                data-theme="light"
                                to={"https://twitter.com/ccsumeerut?ref_src=twsrc%5Etfw"}
                            >
                                Tweets by ccsumeerut
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SocialMedia;
